<div class="scroll-hider">
  <div class="block-list progress">
    <div class="block">
      <div class="title">
        {{ 'dashboard.ui.street_progress.asset_value' | translate }}
      </div>
      <div class="value">{{ nfts?.totalPrice || 0 | precision: 'DWRLD' }} DWRLD</div>
    </div>

    <div class="block">
      <div class="title">
        {{ 'dashboard.ui.street_progress.asset_owned' | translate }}
      </div>
      <div class="value">
        {{ nfts?.totalNfts || 0 }}
      </div>
    </div>

    <div class="block">
      <div class="title">
        {{ 'dashboard.ui.street_progress.total_collections' | translate }}
      </div>
      <div class="value">
        {{ nfts?.totalCollections || 0 }}
      </div>
    </div>
  </div>
</div>

<div class="street-count-progress width-100 display-flex justify-start align-start margin-top-md">
  <div #plan1 class="plan plan1"></div>
  <div #plan2 class="plan plan2"></div>
  <div #plan3 class="plan plan3"></div>
  <div #plan4 class="plan plan4"></div>
  <div #plan5 class="plan plan5"></div>
</div>
